import React, { useContext } from "react";
import { useState } from "react";
import "./ResetPassword.css";
import "./SignInForm.css";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import { Check, Loader } from "react-feather";
import axios from "axios";
import { NotificationContext } from "../../Context/NotificationContext";
import { FormTextInput } from "../../Components/FormTextInput";
import { getFullHttpUrl } from "../../firebase.config";
import { EAST4 } from "../../utility/enums";
import { useCheckoutT } from "../../i18n/checkout";

export default function ResetPassword({
  isLoginOpen,
  backToSignIn,
  handlePasswordChanged,
  email,
  code,
}) {
  const [newPassword, setNewPassword] = useState("");
  const { showNotification } = useContext(NotificationContext);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // English everywhere but the checkout (see i18n/checkout).
  const { t } = useCheckoutT();
  // The button's text, by key (see i18n/checkout/strings/account.js).
  const [btnKey, setBtnKey] = useState("account.reset.button");

  const updatePassword = async () => {
    if (email === "" || newPassword === "" || newPassword.length < 6) {
      setPasswordError(true);
      return;
    }

    setIsLoading(true);
    setBtnKey("account.reset.resetting");

    try {
      const response = await axios.post(
        getFullHttpUrl("resetUserPassword",EAST4),
        {
          email: email.toLowerCase(),
          password: newPassword,
          code,
        }
      );

      if (response.status === 200 && response.data === "success") {
        handlePasswordChanged();
      } else {
        showNotification(
          t("notify.error"),
          t("account.reset.failed"),
          "error"
        );
      }
    } catch (error) {
      console.log(error);
      showNotification(
        t("notify.error"),
        t("account.reset.error"),
        "error"
      );
    } finally {
      setIsLoading(false);
      setBtnKey("account.reset.button");
    }
  };

  const handleNewPassword = (value) => {
    setPasswordError(false);
    setNewPassword(value);
  };

  const triggerEnter = () => {
    if (!(newPassword === "")) {
      updatePassword();
    }
  };

  // An empty field is only an error when saving (see SignInForm).
  const handlePasswordBlur = () => {
    if (newPassword !== "" && newPassword.length < 6) {
      setPasswordError(true);
    }
  };

  return (
    <div className="resetPasswordForm">
      <div className="resetPasswordFormHeader">
        <h2 className="resetPasswordFormTitle">{t("account.reset.title")}</h2>
        <Close
          className="resetPasswordFormIcon"
          onClick={() => isLoginOpen()}
        />
      </div>

      <div className="resetPasswordInputContainer">
        <FormTextInput
          password={true}
          showPasswordIcon={true}
          incorrect={passwordError}
          placeholder={t("account.reset.newPassword")}
          value={newPassword}
          onBlur={handlePasswordBlur}
          onChange={handleNewPassword}
          onKeyDown={(e) => e.key === "Enter" && triggerEnter()}
        />
      </div>

      {newPassword && (
        <span
          className={`passwordValidation ${
            newPassword.length === 0
              ? "invisibleMessage"
              : passwordError
              ? "passwordError"
              : newPassword.length >= 6
              ? "passwordSuccess"
              : "passwordDefault"
          }`}
        >
          <Check className="passwordCheck" />
          {t("account.passwordRule")}
        </span>
      )}

      <button
        className="resetPasswordFormButton"
        disabled={newPassword === "" || isLoading || passwordError}
        onClick={() => updatePassword()}
      >
        {t(btnKey)}
        {isLoading && <Loader className="btnLoader" />}
      </button>
      <span className="resetPasswordFormLogIn" onClick={() => backToSignIn()}>
        {t("account.backToSignIn")}
      </span>
    </div>
  );
}
